export const CoverComposition = Object.freeze({
  SINGLE: 'single',
  COUPLE: 'couple',
  FAMILY: 'family',
  SINGLE_PARENT: 'singleParent',
  CHILDREN_ONLY: 'childrenOnly',
  FAMILY_PLUS: 'familyPlus',
  SINGLE_PARENT_PLUS: 'singleParentPlus'
});

export default CoverComposition;
